<article class="checkpoint" disabled>
    <div class="label">{{ checkpoint.checkPoint.label }}</div>
    <div class="type">{{ checkpoint.checkPoint.valueType | translateEnum: 'checkPointValueType' }}</div>
    <div>
        <mdb-checkbox [checked]="checkpoint.mandatory"
                      (change)="toggleMandatory()"
                      [disabled]="saving"
                      [default]="true"
                      *ngIf="!readOnly"></mdb-checkbox>
    </div>

    <div
            *ngIf="!readOnly">

    <div class="btn-group dropdowns"
         mdbDropdown>
        <i mdbDropdownToggle class="fas fa-ellipsis-h more clickable" id="checkpoint-dropdown-container"></i>
        <div class="dropdown-menu dropdown-primary dropdown-menu-right">
            <a class="dropdown-item"
               [translate]="Localization.DeleteCheckpoint"
               (click)="attemptDelete()"></a>
            <a class="dropdown-item"
               [translate]="Localization.EditCheckpoint"
               (click)="edit()"></a>
            <a class="dropdown-item"
               [translate]="Localization.DuplicateCheckpoint"
               (click)="duplicate()"></a>
        </div>
    </div>
    </div>


    <div class="spinner-border spinner-border-sm"
         role="status"
         *ngIf="saving">
        <span class="sr-only">Loading...</span>
    </div>

</article>

